// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"rK-z","carouselContainer":"sK-z"};